import React, { useEffect, useState } from "react";
import { Accordion } from "react-bootstrap";
import CommonForm from "../../../../../components/commonform/commonForm";
import Loader from "../../../../../components/loader/loader";
import Snackbar from "../../../../../components/snackbar/snackbar";
import CustomTable from "../../../../../components/table/table";
import { user_area_types_list, user_locations_list } from "../../../user.api";
import JointVentureTable from "./optionTable/joint-venture";
import FormOptionTable from "./optionTable/optionTable";
import OwnLand from "./optionTable/ownLand";
import { useAccordionButton } from "react-bootstrap/AccordionButton";
import { useParams } from "react-router-dom";
import BuildUpForm from "./optionTable/buidUp/buildupForm";
import BuilUpFormOptionTable from "./optionTable/buidUp/buildupForm";
import LandFormOptionTable from "./optionTable/land/landForm";
let area_management = [{ id: "1" }, { id: "2" }, { id: "3" }];

export default function AreaDetails(props) {
  const [isActive, setIsActive] = useState(false);
  const [formData, setFormData] = useState(props.areamange);
  const [count, setCount] = useState(1);
  const [locLease, setLocLease] = useState([]);
  const [baseArea, setBaseArea] = useState({});
  const [defaultkey, setdefaultkey] = useState(props.defaultkey);
  const [builtUpTypes, setbuiltUpTypes] = useState({});
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [areaType, setAreaType] = useState("");

  const premise = useParams().id;

  const getlocation = () => {
    setIsActive(true);
    user_locations_list().then((res) => {
      setLocLease(res.data);
      setIsActive(false);
    });
  };

  useEffect(() => {
    getlocation();
  }, []);

  useEffect(() => {
    if (props.areamange) {
      setFormData(props.areamange);
    }
  }, [props.areamange]);

  useEffect(() => {
    if (props.defaultkey !== undefined) {
      setdefaultkey(props.defaultkey);
    }
  }, [props.defaultkey]);

  const handleCheck = (e, id) => {
    setdefaultkey(id);
    setFormData({
      ...formData,
      area_type: e.target.name,
    });
  };

  const handleAccord = (e, name) => {
    if (!props.update) {
      setdefaultkey(e);
      props.handleChangedata(e, name);

      setTimeout(() => {
        setFormData({
          ...formData,
          area_type: name,
        });
      }, 100);
    }
  };

  const handleFormData = (data) => {
    const transformedData = data.map((item) => {
      const transformedItem = { ...item };
      if (item.category === "land") {
        return {
          ...item,
          area_management_id: 3,
          area_in_acres: item.area_in_acres || "",
          location: item.location || "",
          sub_location: item.sub_location || "",
        };
      }
      if (item.category === "built-up") {
        transformedItem.area_management_id = item.area_management_id || 1;
        transformedItem.area_in_sqft = item.area_in_sqft || "";
        transformedItem.built_space_type = item.built_space_type_name || "";
      } else if (item.category === "land") {
        transformedItem.area_management_id = item.area_management_id || 3;
        transformedItem.area_in_acres = item.area_in_acres || "";
      }

      transformedItem.location = item.location || "";
      transformedItem.sub_location = item.sub_location || "";

      return transformedItem;
    });

    setFormData({
      ...formData,
      area_management: transformedData,
    });
  };

  const handleChangedata = (name) => {
    let data = {
      location_id: "",
      location: "",
      area_in_sqft: "",
      investment_model: "",
      management_plan: "",
      area: "",
      land_address: "",
    };
    let land_on = {
      area_in_acres: "",
      location_id: "",
      location: "",
      lease_year: "",
      investment_model: "",
      management_plan: "",
      area: "",
      land_address: "",
    };
    let joint = {
      location_id: "",
      location: "",
      sub_location: "",
      category: "",
      area_in_sqft: "",
      investment_model: "",
      management_plan: "",
    };
    let own = {
      location_id: "",
      location: "",
      sub_location: "",
      survey_no: "",
      block_no: "",
      village_name: "",
      land_address: "",
      management_plan: "",
      nature_of_holding: "",
      area_in_sqft: "",
      interest: "",
    };

    if (name === "built_up_space") {
      return data;
    } else if (name === "equipped_facility") {
      return data;
    } else if (name === "land_on") {
      return land_on;
    } else if (name === "joint_venture") {
      return joint;
    } else if (name === "own_land") {
      return own;
    } else {
      return data;
    }
  };

  const handleValidate = () => {
    if (formData.area_management && formData.area_management !== "") {
      for (let i = 0; i < formData?.area_management?.length;) {
        let flag = false;

        Object.keys(handleChangedata(formData.area_type)).forEach((sub) => {
          if (!formData?.area_management[i][sub] && [sub] != "id") {
            if (
              (!formData?.area_management[0]["location"] ||
                formData?.area_management[0]["location"] == "") &&
              (!formData?.area_management[2]["location"] ||
                formData?.area_management[2]["location"] == "") &&
              (!formData?.area_management[1]["location"] ||
                formData?.area_management[1]["location"] == "")
            ) {
              flag = true;
            }
          } else {
            if (
              sub === "location" &&
              formData?.area_management[i]["location"] !== ""
            ) {
              if (
                formData.area_type === "built_up_space" ||
                formData.area_type === "equipped_facility"
              ) {
                if (formData?.area_management[i]["area_in_sqft"] === "") {
                  flag = true;
                }
              }
              if (formData.area_type === "land_on") {
                if (formData?.area_management[i]["area_in_acres"] === "") {
                  flag = true;
                }
              }
              if (formData.area_type === "joint_venture") {
                const category = formData?.area_management[i]?.category;
                const areaField = category === "land" ? "area_in_acres" : "area_in_sqft";
                if (
                  formData?.area_management[i][areaField] === "" ||
                  !formData?.area_management[i][areaField] ||
                  formData?.area_management[i]["investment_model"] === "" ||
                  formData?.area_management[i]["management_plan"] === "" ||
                  formData?.area_management[i]["category"] === "" ||
                  !formData?.area_management[i]["category"]
                ) {
                  flag = true;
                }
              }
              if (formData.area_type === "own_land") {
                if (
                  formData?.area_management[i]["area_in_sqft"] === "" ||
                  formData?.area_management[i]["nature_of_holding"] === "" ||
                  formData?.area_management[i]["survey_no"] === "" ||
                  formData?.area_management[i]["block_no"] === "" ||
                  formData?.area_management[i]["village_name"] === ""
                ) {
                  flag = true;
                }
              }
            }
          }
        });

        if (flag) {
          return flag;
        } else {
          i++;
        }
      }
    }
  };
  const MIN_BUILTUP_SQFT = 1000;
  const MIN_LAND_CENTS = 25;

  const handlepreview = (e) => {
    // Validate area type is selected
    if (!formData?.area_type) {
      setSnackMessage("Please select area type");
      setIsSnackError(true);
      setSnackOpen(true);
      return;
    }
    
    // Ensure at least one space requirement is provided for the selected type
    const selectedType = formData?.area_type; // 'built_up_space' | 'land_on'
    console.log(selectedType)
    const targetCategory = selectedType === "built_up_space" ? "built-up" : "land";
    // Common validation for all area types
    if (!formData.area_management || formData.area_management.length === 0) {
      setSnackMessage("Please add area requirements");
      setIsSnackError(true);
      setSnackOpen(true);
      return;
    }
    
    // Validate each area requirement for KSPACE premises
    if (selectedType !== "own_land") {
      for (let i = 0; i < formData.area_management.length; i++) {
        const area = formData.area_management[i];
        
        // Mandatory: Location
        if (!area.location_id) {
          setSnackMessage(`Please select location for area requirement ${i + 1}`);
          setIsSnackError(true);
          setSnackOpen(true);
          return;
        }
        
        // Mandatory: Area (Check area_in_acres for land, area_in_sqft for others)
        let areaValue;
        if (selectedType === "joint_venture") {
          areaValue = area.category === "land" ? area.area_in_acres : area.area_in_sqft;
        } else {
          areaValue = selectedType === "land_on" ? area.area_in_acres : area.area_in_sqft;
        }
        if (!areaValue || Number(areaValue) <= 0) {
          const areaLabel = selectedType === "joint_venture"
            ? (area.category === "land" ? "(cents)" : "(sqft)")
            : (selectedType === "land_on" ? "(cents)" : "(sqft)");
          setSnackMessage(`Please enter area ${areaLabel} for area requirement ${i + 1}`);
          setIsSnackError(true);
          setSnackOpen(true);
          return;
        }
      }
    }
    
    // Specific validation for own_land type (Own Premises)
    if (selectedType === "own_land") {
      for (let i = 0; i < formData.area_management.length; i++) {
        const area = formData.area_management[i];
        
        // Mandatory: Location
        if (!area.location_id) {
          setSnackMessage(`Please select location`);
          setIsSnackError(true);
          setSnackOpen(true);
          return;
        }
        
        // Mandatory: Sub Location
        if (!area.sub_location) {
          setSnackMessage(`Please enter sub location`);
          setIsSnackError(true);
          setSnackOpen(true);
          return;
        }
        
        // Mandatory: Survey Number
        if (!area.survey_no) {
          setSnackMessage(`Please enter survey number`);
          setIsSnackError(true);
          setSnackOpen(true);
          return;
        }
        
        // Mandatory: Block Number
        if (!area.block_no) {
          setSnackMessage(`Please enter block number`);
          setIsSnackError(true);
          setSnackOpen(true);
          return;
        }
        
        // Mandatory: Village Name
        if (!area.village_name) {
          setSnackMessage(`Please enter village name`);
          setIsSnackError(true);
          setSnackOpen(true);
          return;
        }
        
        // Mandatory: Land Address
        if (!area.land_address) {
          setSnackMessage(`Please enter address of the property`);
          setIsSnackError(true);
          setSnackOpen(true);
          return;
        }
        
        // Mandatory: Nature of Holding
        if (!area.nature_of_holding) {
          setSnackMessage(`Please select nature of holding`);
          setIsSnackError(true);
          setSnackOpen(true);
          return;
        }
        
        // Mandatory: Area
        if (!area.area_in_sqft) {
          setSnackMessage(`Please enter area`);
          setIsSnackError(true);
          setSnackOpen(true);
          return;
        }
        
        // Mandatory: Joint Venture Interest
        if (!area.interest) {
          setSnackMessage(`Please select joint venture interest`);
          setIsSnackError(true);
          setSnackOpen(true);
          return;
        }
        
        // Conditional: Proposal file required if interest is "yes"
        if (area.interest === "yes" && !area.proposal_file) {
          setSnackMessage(`Please upload proposal file`);
          setIsSnackError(true);
          setSnackOpen(true);
          return;
        }
      }
    }
    
    // Minimum area validation for specific types
    if (formData.area_management && Array.isArray(formData.area_management)) {
      for (let i = 0; i < formData.area_management.length; i++) {
        const item = formData.area_management[i];
        
        if (
          (selectedType === "built_up_space" || selectedType === "joint_venture") &&
          item.category === "built-up" &&
          Number(item.area_in_sqft) > 0 &&
          Number(item.area_in_sqft) < MIN_BUILTUP_SQFT
        ) {
          setSnackMessage(
            "There is a minimum requirement set for Built-up space [1000 sqft]"
          );
          setIsSnackError(true);
          setSnackOpen(true);
          return;
        }
        
        if (
          (selectedType === "land_on" || selectedType === "joint_venture") &&
          item.category === "land" &&
          Number(item.area_in_acres) > 0 &&
          Number(item.area_in_acres) < MIN_LAND_CENTS
        ) {
          setSnackMessage(
            "There is a minimum requirement set for Land [25 cents]"
          );
          setIsSnackError(true);
          setSnackOpen(true);
          return;
        }
      }
    }

    // Skip handleValidate() as we've already done comprehensive validation above
    props.action(2, formData, defaultkey);
  };

  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
  };
  function CustomToggle({ children, onClick }) {
    return (
      <button
        style={{
          width: "100%",
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "flex-start",
          background: "#cdecf5",
          cursor: "pointer",
          padding: "10px",
          border: "1px solid white",
          color: "white",
        }}
        onClick={onClick}
      >
        {children}
      </button>
    );
  }
  return (
    <div className="">
      <Loader open={isActive} />
      {!props?.update && (
        <div className="header-label">
          Provide your space requirement on priority (Maximum 3 locations)
        </div>
      )}
      <div>
        <Accordion defaultActiveKey={defaultkey}>
          {(premise === "kspace" ||
            props?.basics?.area_type == "built_up_space") && (
              <Accordion.Item eventKey="0">
                <CustomToggle
                  onClick={(e) => handleAccord("0", "built_up_space")}
                >
                  <div className="optionLabelHeader-cont">
                    <CommonForm
                      fieldType="radio"
                      disabled={props.disabled}
                      className="to-left-side"
                      name="built_up_space"
                      value={formData.area_type === "built_up_space" ?? false}
                      checked={formData.area_type === "built_up_space" ?? false}
                      onChange={(e) => handleCheck(e, "0")}
                      label="Built-up space on Rent per Month"
                      {...props}
                    />
                  </div>
                </CustomToggle>
                <Accordion.Collapse eventKey={defaultkey}>
                  <Accordion.Body className="area-accordin-body">
                    <div className="table-list-cont">
                      <div className="header-body-spacing">
                        <BuilUpFormOptionTable
                          data={baseArea?.land_on ?? []}
                          key={count}
                          disabled={props.disabled}
                          formData={formData}
                          handleFormData={handleFormData}
                          formvalues={formData?.area_management ?? []}
                        />
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Collapse>
              </Accordion.Item>
            )}

          {/* ///////////////////// */}
          {/* ////Lease/////////////////// */}
          {(premise === "kspace" || props?.basics?.area_type == "land_on") && (
            <Accordion.Item eventKey="2">
              <CustomToggle onClick={(e) => handleAccord("2", "land_on")}>
                <div className="optionLabelHeader-cont">
                  <CommonForm
                    fieldType="radio"
                    className="to-left-side"
                    label="Land on Lease"
                    name="land_on"
                    disabled={props.disabled}
                    value={formData.area_type === "land_on" ?? false}
                    checked={formData.area_type === "land_on" ?? false}
                    onChange={(e) => handleCheck(e, "2")}
                    {...props}
                  />
                </div>
              </CustomToggle>
              <Accordion.Collapse eventKey={defaultkey}>
                <Accordion.Body>
                  <div className="table-list-cont">
                    {/* <div className="tableHeading">Available Space</div>
                    <div className="header-body-spacing">
                      <CustomTable
                        columns={[
                          {
                            title: "No",
                            type: "dynId",
                            field: "id",
                          },
                          {
                            title: "Location",
                            field: "location",
                          },
                          {
                            title: "Area in acres",
                            field: "area_in_acres",
                          },
                          {
                            title: " Rs lakhs/acres",
                            field: "rupees_in_lakhs_or_acres",
                          },
                        ]}
                        data={baseArea?.land_on ?? []}
                      />
                    </div> */}
                    <div className="header-body-spacing">
                      <LandFormOptionTable
                        data={baseArea?.land_on ?? []}
                        key={count}
                        disabled={props.disabled}
                        formData={formData}
                        handleFormData={handleFormData}
                        formvalues={formData?.area_management ?? []}
                        basicData={props?.basicData}
                        update={props.update}
                      />
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Collapse>
            </Accordion.Item>
          )}
          {/* //////////////////////////// */}
          {/* ////////////Joint Venture//////////// */}
          {(premise === "kspace" ||
            props?.basics?.area_type == "joint_venture") && (
              <Accordion.Item eventKey="3">
                <CustomToggle onClick={(e) => handleAccord("3", "joint_venture")}>
                  <div className="optionLabelHeader-cont">
                    <CommonForm
                      fieldType="radio"
                      className="to-left-side"
                      label="Joint Venture"
                      name="joint_venture"
                      disabled={props.disabled}
                      value={formData.area_type === "joint_venture" ?? false}
                      checked={formData.area_type === "joint_venture" ?? false}
                      onChange={(e) => handleCheck(e, "3")}
                      {...props}
                    />
                  </div>
                </CustomToggle>
                <Accordion.Collapse eventKey={defaultkey}>
                  <Accordion.Body>
                    <JointVentureTable
                      {...props}
                      data={locLease}
                      key={count}
                      disabled={props.disabled}
                      formData={formData}
                      handleFormData={handleFormData}
                      formvalues={formData.area_management}
                    />
                  </Accordion.Body>
                </Accordion.Collapse>
              </Accordion.Item>
            )}

          {/* ////////////////////////////////////////////// */}
          {/* ////////////Own Land//////////// */}
          {(premise === "own" || props?.basics?.area_type == "own_land") && (
            <Accordion.Item eventKey="4">
              <CustomToggle onClick={(e) => handleAccord("4", "own_land")}>
                <div className="optionLabelHeader-cont">
                  <CommonForm
                    fieldType="radio"
                    className="to-left-side"
                    label="Own Premises"
                    disabled={props.disabled}
                    name="own_land"
                    value={formData.area_type === "own_land" ?? false}
                    checked={formData.area_type === "own_land" ?? false}
                    onChange={(e) => handleCheck(e, "4")}
                    {...props}
                  />
                </div>
              </CustomToggle>
              <Accordion.Collapse eventKey={defaultkey}>
                <Accordion.Body>
                  <OwnLand
                    {...props}
                    data={locLease}
                    key={count}
                    disabled={props.disabled}
                    formData={formData}
                    handleFormData={handleFormData}
                    formvalues={formData.area_management}
                  />
                </Accordion.Body>
              </Accordion.Collapse>
            </Accordion.Item>
          )}
          {/* ////////////////////////////////////////////// */}
        </Accordion>
      </div>
      <div className="footer-buttons-newreg">
        <div
          className="secondary-btn"
          onClick={(e) => {
            props.action(1, formData);
          }}
        >
          GO BACK
        </div>
        <button onClick={handlepreview} className="primary-btn">
          SUBMIT TO PREVIEW
        </button>
      </div>
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
    </div>
  );
}
